import { Injectable } from '@angular/core';
import { ApiResourceService } from "libraries/service/apiResource/apiResource.service";
import { forkJoin, Observable, of } from "rxjs";
import { HostAliasResource, IHostAlias } from "libraries/service/resources/host-alias/host-alias.resource";
import { flatMap } from "rxjs/internal/operators";
import { IProcessReportBookingItem, IProcessReportResponse, IProcessReportSearchRequest } from "libraries/interfaces/process-report/i-process-report-response";

const BOOKING: string = 'booking';
const BOOKINGS: string = 'bookings';
const WORKFLOW_STATUS: string = 'bookingWorkflowStatus';

@Injectable()
export class ProcessReportResourceService {

    constructor(
        private readonly apiResource: ApiResourceService,
        private readonly hostAliasResource: HostAliasResource,
    ) {
    }

    public searchProcess(request: IProcessReportSearchRequest): Observable<IProcessReportResponse> {
        return forkJoin([
            this.apiResource.postOne(
                this.apiResource.getApiUrl(BOOKING, BOOKINGS, WORKFLOW_STATUS),
                request
            ),
            this.hostAliasResource.getAllAliases(),
        ])
            .pipe(
                flatMap(([response, aliases]: [IProcessReportResponse, IHostAlias[]]): Observable<IProcessReportResponse> => {
                    const bookingArray: IProcessReportBookingItem[] = response.bookingArray
                        .map((item: IProcessReportBookingItem): IProcessReportBookingItem => {
                            const foundAlias: IHostAlias = aliases.find((alias: IHostAlias): boolean => {
                                return alias.host === item.hostCode;
                            });

                            return {
                                ...item,
                                hostCode: foundAlias ? foundAlias.alias : item.hostCode,
                            };
                        });
                    return of({
                        ...response,
                        bookingArray,
                    });
                }),
            )
    }
}
